module.exports = __webpack_public_path__ + "img/smile_success.03d0dab1.svg";